/* Sammy's Catering Co. — shared platters, offered as add-ons in the builder.
   Transcribed from the client's Shared Platters PDF.

   These are priced PER PLATTER, not per person, so each one becomes its own
   cart line with the quantity being how many platters — unlike the package
   itself, where the quantity is the headcount.

   `variantId` is the product each platter adds to the cart as. Items the PDF
   does not give a firm price for have no variantId: they are shown so the
   customer knows they exist, marked as priced on request, and cannot be added
   online. Give them a price and they become orderable like the rest.

   `packages` on each category says which builders offer it by default; the
   step also has a "show everything" toggle, so nothing is ever hidden for
   good. */
window.SAMMYS_ADDONS = {
 "categories": [
  {
   "id": "sandwiches",
   "name": "Sandwiches & Wraps",
   "packages": [
    "working-lunch",
    "full-day-meetings",
    "individual-meals",
    "celebrations-events",
    "corporate-breakfast"
   ],
   "items": [
    {
     "name": "Gourmet finger sandwiches",
     "detail": "Choice of fillings, generously filled",
     "qty": "12 pieces",
     "price": 65,
     "note": "Pro rata from 24 pieces at $130",
     "variantId": 50633456812264
    },
    {
     "name": "Gourmet wraps",
     "detail": "Choice of fillings",
     "qty": "12 pieces",
     "price": 75,
     "note": "Pro rata from 24 pieces at $150",
     "variantId": 50633456910568
    },
    {
     "name": "Bagels",
     "detail": "Poppyseed, plain or sesame, filled and halved",
     "qty": "12 pieces",
     "price": 76,
     "note": "Pro rata from 22 pieces at $140. GF available",
     "variantId": 50633456222440
    },
    {
     "name": "Mini bagels",
     "detail": "Smoked salmon · Turkey, brie & cranberry · Salami & labneh · Prosciutto · Blueberry · Ricotta & honey",
     "qty": "12 pieces",
     "price": 66,
     "variantId": 50633457205480
    },
    {
     "name": "Kafta subs",
     "qty": "12 pieces",
     "price": 78,
     "note": "12 × $6.50 each",
     "variantId": 50633457008872
    },
    {
     "name": "Crispy chicken subs",
     "qty": "12 pieces",
     "price": 72,
     "note": "12 × $6.00 each",
     "variantId": 50633456517352
    }
   ]
  },
  {
   "id": "breakfast",
   "name": "Breakfast & Brunch",
   "packages": [
    "corporate-breakfast",
    "morning-afternoon-tea",
    "full-day-meetings"
   ],
   "items": [
    {
     "name": "Mini flavoured croissants",
     "detail": "Assorted sweet fillings",
     "qty": "12 pieces",
     "price": 30,
     "note": "Pro rata from 24 pieces at $60",
     "variantId": 50633457336552
    },
    {
     "name": "Mini savoury croissants",
     "detail": "Assorted savoury fillings",
     "qty": "12 pieces",
     "price": 27,
     "note": "Pro rata from 24 pieces at $54",
     "variantId": 50633457729768
    },
    {
     "name": "Mini fruit danishes",
     "detail": "Assorted",
     "qty": "12 pieces",
     "price": null,
     "note": "Published as 24 pieces, price not stated"
    },
    {
     "name": "Scones with cream & jam",
     "qty": "12 pieces",
     "price": 48,
     "note": "Count to confirm",
     "variantId": 50633457828072
    },
    {
     "name": "Mini quiche",
     "qty": "12 pieces",
     "price": 48,
     "note": "Count to confirm",
     "variantId": 50633457631464
    },
    {
     "name": "Gourmet sausage rolls",
     "detail": "Lamb & rosemary · Honey mustard chicken · Cheese & spinach",
     "qty": "12 pieces",
     "price": 42,
     "diet": "v",
     "note": "Cheese & spinach is vegetarian",
     "variantId": 50633456845032
    },
    {
     "name": "Yogurt, granola & fruit cups",
     "qty": "12 cups",
     "price": 42,
     "note": "GF and vegan available",
     "variantId": 50633458024680
    },
    {
     "name": "Avocado bites",
     "detail": "Garlic avocado, feta, walnut & pomegranate",
     "qty": "12 pieces",
     "price": 50,
     "diet": "v",
     "note": "Contains walnut",
     "variantId": 50633456124136
    },
    {
     "name": "Brie, cranberry & walnut bites",
     "qty": "12 pieces",
     "price": 48,
     "note": "Contains walnut",
     "variantId": 50633456255208
    },
    {
     "name": "Gourmet muffins",
     "detail": "Range of flavours",
     "qty": "12 pieces",
     "price": null,
     "note": "GF and vegan available"
    },
    {
     "name": "Manouche",
     "detail": "Zaatar · Cheese · Zaatar & cheese · Spinach & sumac · Lahm bi ajin · Cheese & sujuk · Labneh, tomato & mint",
     "qty": "12 wedges",
     "price": null,
     "note": "Zaatar and spinach are vegan"
    }
   ]
  },
  {
   "id": "hot",
   "name": "Hot Finger Food",
   "packages": [
    "working-lunch",
    "full-day-meetings",
    "celebrations-events"
   ],
   "items": [
    {
     "name": "Arancini balls",
     "detail": "Bolognese · Spinach & cheese · Parmesan",
     "qty": "12 pieces",
     "price": 38,
     "diet": "v",
     "note": "Vegetarian or meat",
     "variantId": 50633455993064
    },
    {
     "name": "Falafel",
     "detail": "Served with tahini and pickled vegetables",
     "qty": "12 pieces",
     "price": 35,
     "diet": "vegan gf",
     "variantId": 50633456746728
    },
    {
     "name": "Sombosik",
     "detail": "Meat · Cheese",
     "qty": "12 pieces",
     "price": 38,
     "variantId": 50633457860840
    },
    {
     "name": "Kibbeh",
     "detail": "Meat · Pumpkin",
     "qty": "12 pieces",
     "price": 38,
     "variantId": 50633457041640
    },
    {
     "name": "Vegetarian spring rolls",
     "qty": "12 pieces",
     "price": 38,
     "diet": "v",
     "variantId": 50633457991912
    },
    {
     "name": "Honey halloumi spring rolls",
     "qty": "12 pieces",
     "price": 38,
     "diet": "v",
     "variantId": 50633456943336
    },
    {
     "name": "Mini pizzas",
     "detail": "Nine varieties available",
     "qty": "12 pieces",
     "price": 42,
     "diet": "v",
     "note": "Vegetarian options",
     "variantId": 50633457434856
    },
    {
     "name": "Bruschetta cups",
     "detail": "Served on toasted ciabatta",
     "qty": "12 pieces",
     "price": 48,
     "variantId": 50633456320744
    },
    {
     "name": "Mini meat pies",
     "qty": "12 pieces",
     "price": 39,
     "note": "Pro rata from 20 pieces at $65",
     "variantId": 50633457402088
    },
    {
     "name": "Mini hotdogs",
     "detail": "Onion relish, tomato sauce, mustard",
     "qty": "12 pieces",
     "price": 72,
     "note": "12 × $6.00 each",
     "variantId": 50633457369320
    },
    {
     "name": "Mini burgers",
     "detail": "Kafta · Falafel · Fried fish · Crispy chicken · Grilled chicken · Beef",
     "qty": "12 pieces",
     "price": 78,
     "note": "12 × $6.50 each. Coloured buns extra",
     "variantId": 50633457238248
    },
    {
     "name": "Cocktail skewers",
     "detail": "Prosciutto, rockmelon & bocconcini · Watermelon & halloumi · Antipasto · Brie, prosciutto & fruit",
     "qty": "12 pieces",
     "price": 54,
     "note": "Minimum 2 dozen applies",
     "variantId": 50633456484584
    },
    {
     "name": "Sliders",
     "detail": "Crispy chicken · Beef · Kafta · Falafel · Halloumi · Pulled chicken · Beef brisket",
     "qty": "12 pieces",
     "price": null,
     "note": "Falafel is vegan, halloumi is vegetarian"
    }
   ]
  },
  {
   "id": "dips",
   "name": "Dips, Mezza & Antipasto",
   "packages": [
    "working-lunch",
    "full-day-meetings",
    "celebrations-events"
   ],
   "items": [
    {
     "name": "Individual antipasto cups",
     "detail": "Cold meats, olives, fruits, nuts, cheese",
     "qty": "12 cups",
     "price": 150,
     "note": "12 × $12.50 each. Contains nuts",
     "variantId": 50633456976104
    },
    {
     "name": "Dip platter, small",
     "detail": "Choice of dips with bread and pickles",
     "qty": "Serves 10 to 15",
     "price": 75,
     "variantId": 50633456615656
    },
    {
     "name": "Dip platter, large",
     "detail": "Choice of dips with bread and pickles",
     "qty": "Serves 30+",
     "price": 150,
     "variantId": 50633456582888
    },
    {
     "name": "Antipasto & cheese platter",
     "detail": "Cold meats, cheese, fruits, nuts, crackers",
     "qty": "Confirm",
     "price": null,
     "note": "Halal, vegetarian and GF versions available"
    }
   ]
  },
  {
   "id": "salads",
   "name": "Salads",
   "packages": [
    "working-lunch",
    "full-day-meetings",
    "individual-meals",
    "celebrations-events"
   ],
   "items": [
    {
     "name": "Salad cups",
     "detail": "Individually portioned",
     "qty": "12 cups",
     "price": 72,
     "variantId": 50633457795304
    },
    {
     "name": "Salad, small",
     "detail": "Tabouli · Fattoush · Greek · Rainbow slaw · Roasted pumpkin & couscous · Falafel & halloumi · Potato · Pasta · Caesar",
     "qty": "Serves 10 to 15",
     "price": null,
     "note": "$110 to $160 depending on the salad. Tabouli and fattoush are vegan and DF"
    },
    {
     "name": "Salad, large",
     "detail": "As above",
     "qty": "Serves 30+",
     "price": null,
     "note": "$210 to $260 depending on the salad. Fattoush available GF"
    }
   ]
  },
  {
   "id": "sweets",
   "name": "Fruit & Sweets",
   "packages": [
    "corporate-breakfast",
    "morning-afternoon-tea",
    "working-lunch",
    "full-day-meetings",
    "individual-meals",
    "celebrations-events"
   ],
   "items": [
    {
     "name": "Mini cannoli",
     "detail": "Hazelnut · Chocolate · Ricotta · Pistachio",
     "qty": "12 pieces",
     "price": 42,
     "note": "Some varieties contain nuts",
     "variantId": 50633457271016
    },
    {
     "name": "Chocolate hedgehog",
     "detail": "Traditional Lebanese chocolate and biscuit slice",
     "qty": "12 pieces",
     "price": 42,
     "variantId": 50633456353512
    },
    {
     "name": "Chocolate sombosik",
     "qty": "12 pieces",
     "price": 38,
     "variantId": 50633456386280
    },
    {
     "name": "Fruit custard tarts",
     "qty": "12 pieces",
     "price": 52,
     "variantId": 50633456779496
    },
    {
     "name": "Brownies",
     "detail": "Range of toppings",
     "qty": "12 pieces",
     "price": 72,
     "variantId": 50633456287976
    },
    {
     "name": "Knafeh cups",
     "qty": "12 pieces",
     "price": 72,
     "variantId": 50633457074408
    },
    {
     "name": "Rice pudding cups",
     "qty": "12 pieces",
     "price": 72,
     "variantId": 50633457762536
    },
    {
     "name": "Loaded cupcakes",
     "qty": "12 pieces",
     "price": 76,
     "variantId": 50633457172712
    },
    {
     "name": "Mini cheesecakes",
     "detail": "Range of flavours",
     "qty": "12 pieces",
     "price": 66,
     "note": "12 × $5.50 each",
     "variantId": 50633457303784
    },
    {
     "name": "Donuts, regular",
     "detail": "Caramel · Custard · Nutella · Jam · Gaytime · Biscoff · Pistachio",
     "qty": "12 pieces",
     "price": 84,
     "note": "12 × $7.00 each. Nutella and pistachio contain nuts",
     "variantId": 50633456713960
    },
    {
     "name": "Donuts, mini",
     "detail": "As above",
     "qty": "12 pieces",
     "price": 54,
     "note": "12 × $4.50 each",
     "variantId": 50633456681192
    },
    {
     "name": "Fruit platter",
     "detail": "Seasonal fruit, styled",
     "qty": "Confirm",
     "price": null,
     "diet": "vegan gf",
     "note": "Sold by platter"
    },
    {
     "name": "Knafeh tray, small",
     "detail": "Lotus · Pistachio · Nutella · Regular",
     "qty": "Serves 10 to 15",
     "price": 70,
     "variantId": 50633457139944
    },
    {
     "name": "Knafeh tray, large",
     "detail": "As above",
     "qty": "Serves 30+",
     "price": 150,
     "variantId": 50633457107176
    }
   ]
  }
 ]
};


/* ---------------------------------------------------------------------------
   Every category now shows on every package.

   `packages` above no longer limits where a category appears; it only decides
   which categories start open on that builder. The rest sit collapsed in the
   same step, one click away, so nothing is hidden and the step does not open
   as a wall of seventy rows.
   --------------------------------------------------------------------------- */

/* Drinks: the four drinks products already on the store, priced per bottle.
   Joe's Juice is one product with seven flavour variants and Pellegrino has
   two sizes; each variant is its own row so quantities can be mixed. */
window.SAMMYS_ADDONS.categories.push({
  "id": "drinks",
  "name": "Drinks",
  "unit": "bottle",
  "open": true,
  "items": [
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Orange",
      "name": "Joe’s Juice, Orange",
      "price": 5.5,
      "variantId": 44591423324392,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Mango & Banana",
      "name": "Joe’s Juice, Mango & Banana",
      "price": 5.5,
      "variantId": 44591423357160,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Apple",
      "name": "Joe’s Juice, Apple",
      "price": 5.5,
      "variantId": 44591423389928,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Pineapple",
      "name": "Joe’s Juice, Pineapple",
      "price": 5.5,
      "variantId": 45462877274344,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Green",
      "name": "Joe’s Juice, Green",
      "price": 5.5,
      "variantId": 45462877307112,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "7 Fruits",
      "name": "Joe’s Juice, 7 Fruits",
      "price": 5.5,
      "variantId": 45462877339880,
      "variantLabel": "Flavour"
    },
    {
      "subgroup": "Joe’s Juice",
      "subgroupNote": "Pick a flavour, then how many. Mix as many as you like.",
      "label": "Apple & Blackcurrant",
      "name": "Joe’s Juice, Apple & Blackcurrant",
      "price": 5.5,
      "variantId": 45462877372648,
      "variantLabel": "Flavour"
    },
    {
      "name": "Still Water",
      "price": 3,
      "variantId": 45485664960744
    },
    {
      "subgroup": "Pellegrino",
      "label": "250mL",
      "name": "Pellegrino, 250mL",
      "price": 4,
      "variantId": 44591417164008,
      "variantLabel": "Size",
      "subgroupNote": "Pick a size, then how many."
    },
    {
      "subgroup": "Pellegrino",
      "label": "500mL",
      "name": "Pellegrino, 500mL",
      "price": 6.5,
      "variantId": 44591417196776,
      "variantLabel": "Size",
      "subgroupNote": "Pick a size, then how many."
    },
    {
      "name": "Lightly Sparkling Water",
      "price": 3.5,
      "variantId": 44591420047592
    }
  ]
});

/* The per-person extras from the flow document's "Add Ons (Available on Any
   Package)" table. A package with its own `addons` keeps that list; every
   other package gets these. Copied from buffets, so the products match. */
window.SAMMYS_ADDONS.standardExtras = [
  {
    "name": "Canapés on arrival",
    "detail": "3 pieces per person, finger food and mezze",
    "price": 12,
    "per": "person",
    "variantId": 67732283097320
  },
  {
    "name": "Drinks package",
    "detail": "Juice dispensers and flutes of flavoured juice or sunrise mocktail",
    "price": 9,
    "per": "person",
    "variantId": 67732283523304
  },
  {
    "name": "Dessert platter",
    "detail": "Mini cannoli, brownies and chocolate hedgehog slices",
    "price": 8,
    "per": "person",
    "variantId": 67732283883752
  },
  {
    "name": "Dessert station, live",
    "detail": "Knafeh, donut stuffing or cannoli piping",
    "price": 12,
    "per": "person",
    "minGuests": 50,
    "variantId": 67732284276968
  },
  {
    "name": "Late night snack",
    "detail": "Sliders or kafta subs, served late",
    "price": 10,
    "per": "person",
    "variantId": 67732284637416
  },
  {
    "name": "Kids table",
    "detail": "Veg, fruit, dips, crackers and a sweets platter",
    "price": 120,
    "per": "table",
    "variantId": 67732285030632
  },
  {
    "name": "Hot chips",
    "detail": "Added to any station or buffet",
    "price": 4,
    "per": "person",
    "variantId": 67732293550312
  },
  {
    "name": "Grazing table on arrival",
    "detail": "A styled dips and mezza welcome table",
    "priceLabel": "from $600",
    "link": "/pages/grazing-tables",
    "linkLabel": "Build a table"
  },
  {
    "name": "Styling extras",
    "detail": "Floral, tableware, linen and theming",
    "priceLabel": "On request",
    "link": "/pages/event-catering#enquiry",
    "linkLabel": "Ask us"
  }
];

/* The Extras above are staffed-event add-ons. They show on these packages
   (the other event packages carry their own list in package-menus.js).
   The drop-off packages get the shared platters and drinks only. */
window.SAMMYS_ADDONS.standardExtrasFor = ['celebrations-events'];

/* An extra a tier already includes is hidden in that tier, by package,
   extra name and tier id. */
window.SAMMYS_ADDONS.includedInTier = {
  'canapes': {
    'Canapés on arrival': ['mezza', 'ahla', 'sahtein']
  },
  'celebrations-events': {
    'Canapés on arrival': ['mezza', 'ahla'],
    'Grazing table on arrival': ['mezza', 'ahla'],
    'Styling extras': ['sahtein']
  },
  'live-catering': {
    'Grazing table on arrival': ['ahla'],
    'Dessert station, live': ['sahtein']
  }
};
